// 系统名称
export const title = '广州申迪智能科技有限公司';

// 路由前缀
export const prefixRoute = '';
